

















import {Component, Vue} from "vue-property-decorator";
import {AuthService} from "@/services/auth.service";

@Component({
    name: "Tfa"
})
export default class Tfa extends Vue {

    private auth!: AuthService;

    private status: string | null = null;
    private error: string | null = null;
    private success: string | null = null;

    private async mounted() {
        this.auth = new AuthService();
        if (!this.$route.params.challenge) {
            this.error = "Invalid two-factor auth code. Navigating to home page...";
            this.goHome();
        } else {
            this.status = "Verifying two-factor auth code: " + this.$route.params.challenge + "...";
            await this.submit();
        }
    }

    private async submit() {
        const response = await this.auth.verify(this.$route.params.challenge);
        this.status = null;
        if (response.success) {
            this.success = "Two-factor auth code successfully verified.";
        } else {
            this.error = response.error;
        }
    }

    private goHome() {
        setTimeout(() => {
            this.$router.replace({name: "Home"});
        }, 2000);
    }
}
